// Vendor JS
import $ from 'jquery';
import 'slick-carousel';
import "@fortawesome/fontawesome-free/js/all.js";
import lightGallery from 'lightgallery';

// Vendor CSS
import "slick-carousel/slick/slick.css";
import "@fortawesome/fontawesome-free/css/all.css";

// Custom CSS
import '../scss/app.scss';

$(document).ready(function() {
  if (jQuery(window).width() > 1400) {
    jQuery('.dropdown').hover(function() {
      jQuery(this).addClass('open');
    },
    function() {
      jQuery(this).removeClass('open');
    });
  }

  $(window).scroll(function(){
    if ($(window).scrollTop() >= 100) {
        $('header').addClass('fixed-header');
    }
    else {
        $('header').removeClass('fixed-header');
    }
  });

  jQuery('header .nav-header .navbar .navbar-toggler').click(function() {
    jQuery('body').toggleClass('navbar-open');
  });

  jQuery(".banner-video .scroll img").click(function(e){  
    e.preventDefault();
    jQuery('html, body').animate({
      scrollTop: $("#hero-content").offset().top   
    }, 500);
  });
  
  jQuery(".hero-block .scroll img").click(function(e){  
    e.preventDefault();
    let position = $(".scroll-to-explore-block").offset().top;
    jQuery('html, body').animate({
      scrollTop: position-180
    }, 500);
  });

  if (jQuery(".menu-item").hasClass("menu-item-has-children")) {
    jQuery(".dropdown-menu").before("<a class='nav-link dropdown-toggle' href='#' role='button' data-bs-toggle='dropdown'><span class='visually-hidden-text'>Open Menu Item</a></a>");
  }

  jQuery('.logo-slider .logo-wrapper').slick({
    centerMode: true,
    slidesToShow: 7,
    arrows: false,
    loop: true,
    autoplay: true,
    autoplaySpeed: 2500,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 480,
        settings: {
          centerPadding: '40px',
          slidesToShow: 1,
        }
      }
    ]
  });


  jQuery('.testimonial .testimonial-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoPlay: true, 
    autoplaySpeed: 5000,
    fade: true,
    infinite: true,
    adaptiveHeight: true
  });


  jQuery('.image-carousel').slick({
    centerMode: false,
    slidesToShow: 1,
    arrows: true,
    autoPlay: false,
    dots: true,
    centerPadding: '0px',
    infinite: false
  });

  jQuery('.image-carousel-details').slick({
    centerMode: false,
    slidesToShow: 1, 
    arrows: true,
    autoPlay: true,
    dots: false,
    centerPadding: '0px',
    infinite: false
  });
  
  jQuery( ".btn-gallery" ).click(function(e){
    e.preventDefault();
    jQuery(window).trigger('resize');
    jQuery('.image-carousel-details').slick("refresh");
  });

  $('#chooseFile').bind('change', function () {
    var filename = $("#chooseFile").val();
    if (/^\s*$/.test(filename)) {
      $(".file-upload").removeClass('active');
      $("#noFile").text("No file chosen..."); 
    }
    else {
      $(".file-upload").addClass('active');
      $("#noFile").text(filename.replace("C:\\fakepath\\", "")); 
    }
  });
  var imgHeight = jQuery( '.lg-object.lg-image' ).height();
  jQuery('.lg-inner').css("height", imgHeight);

  jQuery( "#lightgallery .owl-item" ).click(function(){
    var imgHeight = jQuery( '.lg-object.lg-image' ).height();
    jQuery('.lg-inner').css("height", imgHeight);
  });

  jQuery( ".title-content-image-carousel .custom-card" ).click(function(){
    var imgHeight = jQuery( '.lg-object.lg-image' ).height();
    jQuery('.lg-inner').css("height", imgHeight);
  });

  $('#example-1').progress_fnc();
  $('#example-2').progress_fnc();
  $('#example-3').progress_fnc();
  $('#example-4').progress_fnc();
  $('#example-5').progress_fnc();
  $('#example-6').progress_fnc();
  $('#example-7').progress_fnc();
  $('#example-8').progress_fnc();
  $('#example-9').progress_fnc();
  $('#example-10').progress_fnc();
  $('#example-11').progress_fnc();
  $('#example-12').progress_fnc();
  $('#example-13').progress_fnc();

  $('.progressStart').on('click', function() {
    var perent = $(this).closest("div").attr("id");
    $('#' + perent).progress_fnc({ type: 'start' });
  });

  $('.progressReset').on('click', function() {
    var perent = $(this).closest("div").attr("id");
    $('#' + perent).progress_fnc({ type: 'reset' });
  });
});

jQuery( window ).resize(function() {
  var imgHeight = jQuery( '.lg-object.lg-image' ).height();
  jQuery('.lg-inner').css("height", imgHeight);
});


(function($) {

  $.fn.progress_fnc = function(options) {
    var settings = $.extend({
      type: 'start'
    }, options);

    var div = $(this);
    var progress = div.find('.cssProgress');

    progress.each(function() {
      var self = $(this);
      var progress_bar = self.find('.cssProgress-bar');
      var progress_label = self.find('.cssProgress-label, .cssProgress-label2');
      var progress_value = progress_bar.data('percent');
      var percentage = parseInt(progress_value, 10) + '%';
    });
  }

}(jQuery));

// START Light Gallery used on the gallery page. Extracted and reworked from swf-cards.php
// NOTE: The lightgallery instantiation is still happening in swf-cards.php and seems to be an outdated version and breaks when trying to move into here.
$(document).ready(function() {
  if ( $('body').hasClass('post-type-archive-gallery') ) {
    const filterCheckboxes = document.querySelectorAll('.dropdown-check-list li');
    const params = getAllGalleryParams();

    // Add click event to each filter checkbox
    filterCheckboxes.forEach((checkbox, index) => {
      checkbox.addEventListener('click', function(event) {
        syncFilterCheckboxUrl(event.target.parentElement);
      });
    });

    // Add click event to each gallery card
    $('body.post-type-archive-gallery').on('click', '.gallery-card', (event) => {
        event.preventDefault();
        const card = event.target.closest('.gallery-card');

        syncGalleryUrl(card);
        addGalleryCloseListener();
        addGalleryNextPrevListener();
    });

    // If there is a title in the URL, open the gallery item with that title
    if ( params && params.title ) {   
      openGalleryItem(params.title);
    }

    // If there is project_type in the url, filter the gallery items
    if ( params && params.project_types ) {
      filterGalleryItems(params.project_types);
    }

    function filterGalleryItems(terms) {
      const checkboxes = document.querySelectorAll('.checkbox-group');
      
      checkboxes.forEach((checkbox, index) => {
        const input = checkbox.querySelector('input');
        const label = checkbox.querySelector('label');
        
        if (htmlDecode(terms).includes(label.innerText)) {
          label.click();
        }
      });
    }

    function htmlDecode(input) {
      var doc = new DOMParser().parseFromString(input, "text/html");
      return doc.documentElement.textContent;
    }
    

    function getAllGalleryParams() {
      const searchParams = new URLSearchParams(window.location.search);
      const galleryParams = {};

      for (const [key, value] of searchParams.entries()) {
        galleryParams[key] = value;
      }

      return galleryParams;
    }

    function openGalleryItem(title) {
      const item = document.querySelector(`.custom-card[data-title="${title}"]`);

      item.click();

      syncGalleryUrl(item);

      addGalleryCloseListener();
      addGalleryNextPrevListener();
    }

    function closeGalleryItem() {
      const url = new URL(window.location.href);
      url.searchParams.delete('title');
      url.searchParams.delete('terms');

      window.history.pushState({}, '', url);
    }

    function syncFilterCheckboxUrl(checkbox) {
      const url = new URL(window.location.href);
      const filterCheckboxes = document.querySelectorAll('.dropdown-check-list li');

      let project_types = '';

      filterCheckboxes.forEach((checkbox, index) => {
        let input = checkbox.querySelector('input');
        let label = checkbox.querySelector('label');

        if ( input.checked ) {
          project_types += `${label.innerText}`;
    
          if ( index > 0 ) project_types += ',';
        }
      });

      url.searchParams.set('project_types', project_types);

      window.history.pushState({}, '', url);
    }

    function syncGalleryUrl(element) {
      const url = new URL(window.location.href);
      const title = element.getAttribute('data-title');
      const terms = element.getAttribute('data-terms');
      
      if (title) {
        url.searchParams.set('title', title);
      }

      if (terms) {
        url.searchParams.set('terms', terms);
      }

      window.history.pushState({}, '', url);
    }

    function addGalleryCloseListener() {
      const closeBtn = document.querySelector('.lg-close');
      
      if ( !closeBtn ) return;
      
      closeBtn.addEventListener('click', function() {
        closeGalleryItem();
      });
    }

    function addGalleryNextPrevListener() {
      const nextBtn = document.querySelector('.lg-next');
      const prevBtn = document.querySelector('.lg-prev');
        
      if (nextBtn === null || prevBtn === null) return;
      
      nextBtn.addEventListener('click', function() {
        // TODO - find a better way to avoid calling settimeout, ideally we should be able to listen to the event that is emitted when the slide changes
        setTimeout(() =>{
          handleGalleryNavigation();
        }, 500)
      });

      prevBtn.addEventListener('click', function() {
        // TODO - find a better way to avoid calling settimeout, ideally we should be able to listen to the event that is emitted when the slide changes
        setTimeout(() =>{
          handleGalleryNavigation();
        }, 500)
      });
    }

    function handleGalleryNavigation() {
      const slide = document.querySelector('.lg-current');
      const image = slide.querySelector('img');
      const cards = document.querySelectorAll('.custom-card');

      if ( cards.length === 0 ) return;
      
      cards.forEach((card, index) => {
        const cardImage = card.querySelector('img');

        if (image.src === cardImage.src) {
          syncGalleryUrl(card);
        }
      });
    }

    // We have to add custom events for the lightGallery because the old version of the plugin doesn't seem to be emitting any events to key off of
    // TODO - Add custom events for changing the slides
    // TODO - Add custom events for closing/opening the gallery
    // TODO - Add custom events for esc and arrow keys
    // TODO - Change the URL when the gallery is opened [DONE]
    // TODO - Change the URL when the gallery is opened/changing slides
    // TODO - Change the URL when the gallery is closing
  }
});
// END Light Gallery used on the gallery page. Extracted and reworked from swf-cards.php




$(document).ready(function() {
  // delete set cookies
  // document.cookie = "virtualTourPartnerForm=; Max-Age=0; path=/";
  // document.cookie = "virtualTourTeamForm=; Max-Age=0; path=/";
  
  const tourVid = $(".virtual-tour-videos #lightgallery0");
  

  if (["/virtual-tour-partner/", "/virtual-tour-team/"].includes(window.location.pathname)) { 
    const partnerValue = ('; '+document.cookie).split(`; virtualTourPartnerForm=`).pop().split(';')[0];
    const teamValue = ('; '+document.cookie).split(`; virtualTourTeamForm=`).pop().split(';')[0];
    
    if (window.location.pathname === "/virtual-tour-partner/" && partnerValue === "true") {
      $("#cf7-thank-you-virtual-tour").hide();
      tourVid.show();
    } else if (window.location.pathname === "/virtual-tour-team/" && teamValue === "true") {
      $("#cf7-thank-you-virtual-tour").hide();
      tourVid.show();
    }
  }


  document.addEventListener(
    "wpcf7mailsent",
    function (event) {
      if (
        // LIVE AND DEV FORM IDS
        [4556, 4553].includes(event.detail.contactFormId)
      ) {
        let currentDate = new Date();
        
        currentDate.setFullYear(currentDate.getFullYear() + 1);

        let expirationDate = currentDate.toUTCString();
        
        if (window.location.pathname === "/virtual-tour-partner/" && event.detail.contactFormId === 4556) {
          document.cookie = "virtualTourPartnerForm=true; expires=" + expirationDate + "; path=/";
        } else if (window.location.pathname === "/virtual-tour-team/" && event.detail.contactFormId === 4553) {
          document.cookie = "virtualTourTeamForm=true; expires=" + expirationDate + "; path=/";
        }

        $("#cf7-thank-you-virtual-tour").hide();
        tourVid.show();
      }
    },
    false
  );

  $(".gated-tour select").on("change", function() {
    if ($(this).val() === "Other") {
      $(".gated-tour .other-option").show();
    } else {
      $(".gated-tour .other-option").hide();
    }
  });

  $(".in-person select").on("change", function() {
    if ($(this).val() === "Other") {
      $(".in-person .other-option").show();
    } else {
      $(".in-person .other-option").hide();
    }
  });
});